import type { ScenarioDefinition } from "./types.js";
import { CHAPTER_ONE_STORY } from "./chapter01Story.js";

export const CHAPTER_ONE: ScenarioDefinition = Object.freeze({
  id: "chapter-01",
  chapter: 1,
  numberLabel: "第一章",
  title: "帰る匂い",
  performanceTitle: "夢幻小景《帰らずの散歩道》",
  goal: "男の幸福度を13〜15へ着地させる",
  startLog: "男と犬の夢が重なり、《帰らずの散歩道》が始まった。",
  stageId: "looping-street",
  rules: Object.freeze([]),
  story: CHAPTER_ONE_STORY,
  battle: Object.freeze({
    seed: 20260712,
    stageId: "looping-street",
    playerNames: Object.freeze(["男", "犬"]) as readonly [string, string],
    servantIds: Object.freeze(["flint", "flint"]) as readonly [string, string],
    opponentPlans: Object.freeze({
      1: Object.freeze({ focusLane: 1, pass: true }),
      2: Object.freeze({
        focusLane: 1,
        cardId: "familiar_lamppost",
        target: Object.freeze({ lane: 1 }),
      }),
      3: Object.freeze({
        focusLane: 1,
        cardId: "red_ball",
        target: Object.freeze({ lane: 3 }),
      }),
      4: Object.freeze({
        focusLane: 1,
        cardId: "apple",
        target: Object.freeze({ lane: 1 }),
      }),
      5: Object.freeze({
        focusLane: 2,
        cardId: "snake",
        target: Object.freeze({ lane: 3 }),
      }),
      6: Object.freeze({ focusLane: 3, pass: true }),
    }),
    tutorialRules: Object.freeze({
      1: Object.freeze({
        requiredCardId: "cloud",
        requiredLane: 2,
        requiredFocusLane: 2,
        allowPass: false,
        prompt: "最初は基本から。演出卓の《雲のゆりかご》を中央へ置き、注目もL2へ合わせて。",
      }),
      2: Object.freeze({
        prompt: "ここからは自由。カードを使うか、何も置かずに注目だけを動かしてもいい。注目は一時間に隣のレーンまで。",
      }),
      3: Object.freeze({
        prompt: "夢は時間の終わりにD3からD2、D1へ浅くなり、その次に《窓》から消える。深度で影響値も変わるよ。",
      }),
      4: Object.freeze({
        prompt: "ご主人へ届くのは注目レーンの夢だけ。同じマスへ重なった夢は、影響を足し合わせて合体する。",
      }),
      5: Object.freeze({
        prompt: "献身は一夜に一度だけ使える切り札。今使っても、最後まで取っておいても構わない。",
      }),
      6: Object.freeze({
        prompt: "最後の一手。男の幸福度を13〜15に着地させて。16以上は寝坊、0以下は悪夢だよ。",
      }),
    }),
  }),
});
